import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('ShowMoreContainer', [
  'ctaButton',
  'ctaIcon',
  'standard',
  'silent',
  'content',
]);

const getShowMoreContainerCss = css`
  .${classes.ctaButton} {
    margin-bottom: var(--cds-spacing-100);
    text-align: left; /* overrides default center-aligned button */
    align-items: center;
    border-radius: var(--cds-border-radius-50);
  }

  .${classes.ctaIcon} {
    flex-shrink: 0;
    color: inherit;
    transform: rotate(0deg);
    transition: transform 150ms ease-in-out;

    &.expanded {
      transform: rotate(180deg);
    }
  }

  .${classes.content} {
    overflow: hidden;

    &.${classes.standard} {
      border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
      border-radius: var(--cds-border-radius-200);
      padding: var(--cds-spacing-200);
      background: var(--cds-color-neutral-background-primary);
    }

    &.${classes.silent} {
      background: transparent;
    }
  }
`;

export default getShowMoreContainerCss;
